module.exports = __webpack_public_path__ + "img/card_sv5.78a7c3e.png";